import { fabric } from "fabric";
import { applyGoogleFontHandler, clickStepBtnHandler, TechniqueBaseSingleColor, updateAngleText } from "../productConfiguration/util";
import { clearInputBoxHandler, getCanvasEditor, getCurrentCanvas, getSelectedTechnique, rgbToHex, validateNumericInput } from "../../helpers/helper";
import { errorMessages } from "../../assets/config";

export const isTextPresentInCurrentPosition = () => {
  const addedTexts =  getCurrentCanvas()?.getObjects()?.filter((obj) => obj.type === "textbox") ?? [];
  if(addedTexts?.length >= 1){
    alert(errorMessages?.LOGO_TEXT_LIMIT);
    return true;
  }
  return false;
}

export function addTextToCanvasHandler() {
  const addTextButton = document.getElementById("applyText");

  function handleClick(){
    let addedText = (document.getElementById("addedText") as HTMLInputElement).value;
    if(isTextPresentInCurrentPosition()){
      clearInputBoxHandler("addedText");
      return;
    }
    if(!addedText){
      alert(errorMessages?.TEXT_EMPTY);
      return;
    }
    if (addedText) {
      const techColor = TechniqueBaseSingleColor();
      const selectedTechnique= getSelectedTechnique()
      const text = new fabric.Textbox(addedText, {
        editable: false,
        transparentCorners: false,
        fill: selectedTechnique?.is_single_color_selected ? selectedTechnique.selected_color  : rgbToHex(techColor[0], techColor[1], techColor[2]),
        fontSize: 24
      });
      const editor = getCanvasEditor();
      setTextWidth(text);
      const top = editor.top + (editor.height - text.height) / 2;
      const left = editor.left + (editor.width - text.width) / 2;

      text.set({
        top: top,
        left: left,
      });
      clearInputBoxHandler("addedText");
      getCurrentCanvas().add(text);
      getCurrentCanvas().setActiveObject(text);
    }
  }

    // Remove any existing listener before adding a new one
    addTextButton?.removeEventListener("click", handleClick);
    addTextButton?.addEventListener("click", handleClick);
}

export const changeFontFamilyHandler = () => {
  const fontType = document.getElementById("fontType") as HTMLSelectElement;
  if (!fontType) return;
  const updateDropdpwnValue = (e) => {
    fontType.value = e.selected[0].fontFamily.replaceAll(" ", "-");
  };
  const onDeselectHandler = () => {
    fontType.value = "Times-New-Roman";
  };

  canvasSelectEventHandler(updateDropdpwnValue, onDeselectHandler);

  fontType.addEventListener("change", () => {
    const activeObject = getCurrentCanvas().getActiveObject();
    if (activeObject instanceof fabric.Text) {
      applyGoogleFontHandler(fontType.value.replaceAll("-", " "), activeObject);
    }
    getCurrentCanvas().renderAll();
  });
};

export const changeFontSizeHandler = () => {
  const fontSize = document.getElementById("fontSize") as HTMLInputElement;
  if (!fontSize) return;
  const updateInpuBoxValue = (e) => {
    fontSize.value = e.selected[0].fontSize;
  };

  const onDeselectHandler = () => {
    fontSize.value = "24";
  };

  canvasSelectEventHandler(updateInpuBoxValue, onDeselectHandler);

  const handleTextSizeChange = (currentFontSize) => {
    const activeObject = getCurrentCanvas().getActiveObject();
    if (activeObject instanceof fabric.Text) {
      activeObject._clearCache();
      activeObject.set({
        width: 20,
        // @ts-ignore
        fontSize: currentFontSize,
      });
      setTextWidth(activeObject);
      getCurrentCanvas().fire("object:modified");
      getCurrentCanvas().renderAll();
    }
  }

  fontSize.addEventListener("keydown", validateNumericInput)
  fontSize.addEventListener("input", (event) => {
    handleTextSizeChange(event.target.value ?? "24")
  });

  fontSize.addEventListener("blur",(e) => {
      if(!e.target.value || e.target.value === "0"){
        fontSize.value = "24";
        handleTextSizeChange("24")
      }
  })

  getCurrentCanvas().on("object:selected", function (options) {
    if (options.target) {
      fontSize.value = options.target.fontSize;
    }
  });
};

export const fontBoldUnderlineAndItalicHandler = () => {
  const styleHelperArray = ["fontStyle", "fontWeight", "textDecoration"];
  const boldCheckbox = document.getElementById("fontBold") as HTMLInputElement;
  const italicCheckbox = document.getElementById("fontItalic") as HTMLInputElement;
  const underlineCheckbox = document.getElementById("fontUnderline") as HTMLInputElement;

  const boldLabel = document.getElementById("boldFontLabel");
  const italicLabel = document.getElementById("italicFontLabel");
  const underlineLabel = document.getElementById("underlineFontLabel");

  const checkBoxesAndLabels = [
    { checkBox: boldCheckbox, label: boldLabel },
    { checkBox: italicCheckbox, label: italicLabel },
    { checkBox: underlineCheckbox, label: underlineLabel },
  ];

  const updateFontStyles = () => {
    const activeObject = getCurrentCanvas().getActiveObject();

    if (activeObject instanceof fabric.Text) {
      const isBold = boldCheckbox.checked;
      const isItalic = italicCheckbox.checked;
      const isUnderline = underlineCheckbox.checked;
      activeObject.set({
        fontWeight: isBold ? "bold" : "100",
        fontStyle: isItalic ? "italic" : "normal",
        underline: isUnderline,
      });

      styleHelperArray.forEach((style) => {
        selectedTextBoxStyleHelper(style, activeObject);
      });

      checkBoxesAndLabels.forEach(({ checkBox, label }) => {
        label.classList.toggle("active", checkBox.checked);
      });
      getCurrentCanvas().fire("object:modified");
    }

    getCurrentCanvas().renderAll();
  };

  const updateCheckboxes = (e) => {
    boldCheckbox.checked = e.selected[0].fontWeight === "bold";
    italicCheckbox.checked = e.selected[0].fontStyle === "italic";
    underlineCheckbox.checked = e.selected[0].underline;
    boldLabel.classList.toggle("active", e.selected[0].fontWeight === "bold");
    italicLabel.classList.toggle("active", e.selected[0].fontStyle === "italic");
    underlineLabel.classList.toggle("active", e.selected[0].underline);
  };

  const onDeselectHandler = () => {
    checkBoxesAndLabels.forEach(({ checkBox, label }) => {
      checkBox.checked = false;
      label.classList.remove("active");
    });
  };

  canvasSelectEventHandler(updateCheckboxes, onDeselectHandler);

  checkBoxesAndLabels.forEach(({ checkBox }) => {
    checkBox.addEventListener("change", updateFontStyles);
  });
};

export const changeTextColor = () => {
  const textColorInputbox = document.getElementById("textColor") as HTMLInputElement;
  const selectedTechnique= getSelectedTechnique()
  if (selectedTechnique.is_single_color_selected) {
    textColorInputbox.disabled = true;
  } else {
    textColorInputbox.disabled = false;
  }
  const updateInpuBoxValue = (e) => {
    textColorInputbox.value = e.selected[0].fill;
  };

  const onDeselectHandler = () => {
    textColorInputbox.value = "black";
  };

  canvasSelectEventHandler(updateInpuBoxValue, onDeselectHandler);

  textColorInputbox?.addEventListener("input", () => {
    const activeObject = getCurrentCanvas().getActiveObject();
    const newColor = (document.getElementById("textColor") as HTMLInputElement).value;

    if (newColor && activeObject instanceof fabric.Text) {
      activeObject.set("fill", newColor);
      selectedTextBoxStyleHelper("color", activeObject);
      getCurrentCanvas().renderAll();
    }
  });

  textColorInputbox?.addEventListener("change", () => {
    getCurrentCanvas().fire("object:modified");
  });
};

export const changeTextAlignHandler = () => {
  const textAlign = document.getElementById("textAlign") as HTMLSelectElement;
  const updateDropdpwnValue = (e) => {
    textAlign.value = e.selected[0].textAlign;
  };

  const onDeselectHandler = () => {
    textAlign.value = "left";
  };

  canvasSelectEventHandler(updateDropdpwnValue, onDeselectHandler);

  if (textAlign) {
    textAlign.addEventListener("change", () => {
      const activeObject = getCurrentCanvas().getActiveObject();
      if (activeObject instanceof fabric.Text) {
        activeObject.set("textAlign", textAlign.value);
        selectedTextBoxStyleHelper("textAlign", activeObject);
        getCurrentCanvas().fire("object:modified");
      }
      getCurrentCanvas().renderAll();
    });
  }
};

/*
 * style : the name of the CSS property you need to update
 * activeObject : selected textBox
 */
export const selectedTextBoxStyleHelper = (style, activeObject) => {
  const selectedTextBox = document.getElementById("selectedText") as HTMLInputElement;
  const styleMap = {
    textAlign: "textAlign",
    fontFamily: "fontFamily",
    // color: "fill",
    fontStyle: "fontStyle",
    fontWeight: "fontWeight",
    textDecoration: (value) => (value ? "underline" : "none"),
  };

  const property = styleMap[style];
  if (property) {
    let value;

    if (typeof property === "function") {
      value = property(activeObject[style === "textDecoration" ? "underline" : style]);
    } else {
      value = activeObject[property];
    }
    selectedTextBox.style[style] = value;
  }
  setTextWidth(activeObject);
};

export const editTextHandler = () => {
  const styleHelperArray = ["textAlign", "fontFamily", "color", "fontStyle", "fontWeight", "textDecoration"];
  const selectedTextBox = document.getElementById("selectedText") as HTMLInputElement;
  const textEditorBox = document.getElementById("textEditorBox");

  const addTextToSelectedTextBox = () => {
    const activeObject = getCurrentCanvas().getActiveObject();
    if (activeObject instanceof fabric.Text) {
      selectedTextBox.value = activeObject.text;
      styleHelperArray.forEach((style) => {
        selectedTextBoxStyleHelper(style, activeObject);
      });
    }
  };

  const onDeselectHandler = () => {
    textEditorBox.style.display = "none";
    clearInputBoxHandler("selectedText");
  };

  canvasSelectEventHandler(addTextToSelectedTextBox, onDeselectHandler);

  selectedTextBox.addEventListener("input", (event) => {
    const activeObject = getCurrentCanvas().getActiveObject();
    if (activeObject instanceof fabric.Text) {
      activeObject._clearCache();
      activeObject.set({
        width: 20,
        text: (event.target as HTMLInputElement).value,
      });
      setTextWidth(activeObject)
      getCurrentCanvas().renderAll();
      getCurrentCanvas().fire("object:modified");
    }
  });
};

/*
 * getCurrentCanvas() : selection area getCurrentCanvas()
 * updateFunction : the function you need to call when the textbox selection changes
 */
export const canvasSelectEventHandler = (updateFunction, clearFunction) => {
  const textEditorBox = document.getElementById("textEditorBox");

  const handleSelection = (e) => {
    updateAngleText(e?.selected?.[0])
    const hasSelectedText = e?.selected?.[0]?.text;
    textEditorBox.style.display = hasSelectedText ? "flex" : "none";
    hasSelectedText ? updateFunction(e) : clearFunction();
    clickStepBtnHandler(1);
  };

  getCurrentCanvas().off("selection:updated", handleSelection);
  getCurrentCanvas().off("selection:created", handleSelection);
  getCurrentCanvas().off("selection:cleared", clearFunction);

  getCurrentCanvas().on("selection:updated", handleSelection);
  getCurrentCanvas().on("selection:created", handleSelection);
  getCurrentCanvas().on("selection:cleared", clearFunction);
};

export const hideTextEditorHandler = () => {
  const textEditorBox = document.getElementById("textEditorBox");
  textEditorBox.style.display = "none";
};


export const setTextWidth = (activeObject)=>{
  if (activeObject?.text) {
      activeObject.set({ width: 20 });
      // Use Fabric's `Text` object to measure width
      const context = document.createElement('canvas').getContext('2d');
      context.font = `${activeObject.fontStyle} ${activeObject.fontWeight} ${activeObject.fontSize}px ${activeObject.fontFamily}`;
      
      const textWidth = context.measureText(activeObject.text).width; // Get the width of the text
      const newWidth = Math.max(textWidth + 5, activeObject.width); // Ensure the width is at least as wide as the current width
  
      activeObject.set({ width: newWidth });
    }
}